import React, { Component } from 'react';

import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Navbar from 'react-bootstrap/Navbar';
import Spinner from 'react-bootstrap/Spinner';
import { Link } from 'react-router-dom';
import Countdown from 'react-countdown';


import DataFiliale from '../components/DataFiliale'


import Imei from '../components/Imei';
import AusstellerListe from '../components/AusstellerListe';
import VerteilungListe from '../components/VerteilungListe';

export default class Home extends Component {

    constructor(props) {
        super(props);
    
        this.state = {
          isUserAuthenticated: false,
          exTools: null,
          pCode: '',
          filiale: null,
          filialen: [],
          token: null,
          page: 'home',
          maxTimer: 0,
          dateLogon: null
        }
    
        this.pcode = null;
        this.token = null;
        this.fetchAddress = '';
        this.fetchBody = '';

        this.changeFiliale = this.changeFiliale.bind(this);
        this.onSetTimer = this.onSetTimer.bind(this);
    
      }

      


    componentDidMount() {
      this.setState({
        filiale: sessionStorage.getItem('filiale'),
        page: this.props.page,
        dateLogon: this.props.dateLogon
      })
    }

    componentDidUpdate() {
    }

    changeFiliale(value) {
      sessionStorage.setItem('filiale', value);
      this.setState({filiale: value});
    }

    onClickExit() {
     //console.log('onClickExit triggered');
      sessionStorage.clear();
      window.location.reload(false);
    }

    onSetTimer(maxTimer) {
      this.setState({
        maxTimer: maxTimer,
        dateLogon: Date.now()
      });
    }

    render() {
      const exTools = JSON.parse(sessionStorage.getItem('exTools'));
      
      const filialen = JSON.parse(sessionStorage.getItem('exFilialen'));

      const filiale = filialen[this.state.filiale];

      const maxTimer = this.props.maxTimer;

      // Custom Renderer für Minuten und Sekunden
      const countdownRenderer = ({ minutes, seconds }) => {
        return (
            <span 
              className='text-warning' >
                {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
            </span>
        );
      };

     //console.log('filiale', filiale);

            const menuMap = {
              imei: {
                name: 'Imei Erfassung',
                content: <Imei maxTimer={this.state.maxTimer} onSetTimer={this.onSetTimer} />
              },
              aussteller: {
                name: 'Aussteller',
                content: <AusstellerListe maxTimer={this.state.maxTimer} onSetTimer={this.onSetTimer} />
              },
              verteilung: {
                name: 'Artikel Verteilung',
                content: <VerteilungListe maxTimer={this.state.maxTimer} onSetTimer={this.onSetTimer} />
              },
              home: {
                name: 'expert Tools',
                content: <Container style={{padding: "5rem 0px 0px 0px"}} className="text-center" >
                      <Row className='mb-3'>
                        <Col>
                          <Link onClick={() => {this.setState({ page: "aussteller" })}} className="btn btn-primary btn-lg" style={{height: '6em', width: '8em', verticalAlign: 'middel'}}><br />Aussteller</Link>
                        </Col>
                        <Col>
                          <Link onClick={() => {this.setState({ page: "verteilung" })}} className="btn btn-primary btn-lg" style={{height: '6em', width: '8em', verticalAlign: 'middel'}}><br />Bestand<br />Verteilung</Link>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Link onClick={() => {this.setState({ page: "imei" })}} className="btn btn-primary btn-lg" style={{height: '6em', width: '8em', verticalAlign: 'middel'}}><br />IMEI / SN<br /> Erfassung</Link>
                        </Col>
                        <Col>
                          {/* <Link onClick={() => {this.setState({ page: "home" })}} className="btn btn-primary btn-lg" style={{height: '6em', width: '8em', verticalAlign: 'middel'}}><br />Zwischen<br />Inventur</Link> */}
                        </Col>
                      </Row>
                    </Container>
              }

            };

            //const filialen = JSON.parse(sessionStorage.getItem('exFilialen'));
            if(filiale) {
              return (
                      <>
                        <Navbar fixed="top" className="bg-body-tertiary justify-content-between" bg="dark" data-bs-theme="dark">
                          <Container fluid>
                            <Navbar.Text>{exTools.MitarbeiterName} (
                                <Countdown 
                                  date={this.state.dateLogon + maxTimer * 1000} 
                                  renderer={countdownRenderer}    
                                  onComplete={() => {this.onClickExit()}}                               
                                /> 
                                
                              )

                            </Navbar.Text>
                            {
                              this.state.page === 'home'
                              ? <>
                                  <Navbar.Text>{menuMap[this.state.page].name}</Navbar.Text>
                                  <DataFiliale filialeList={filialen} onChangeFiliale={this.changeFiliale} valueFiliale={this.state.filiale} />
                                  <Navbar.Text onClick={this.onClickExit}><i className="bi bi-box-arrow-right"></i> Logout</Navbar.Text>
                                </>
                              : <>
                                  <Navbar.Text className='text-white'>{menuMap[this.state.page].name} {filiale.bezeichnung || null}</Navbar.Text>
                                  <Navbar.Text onClick={() => {this.setState({ page: "home" })}} className='nav-link'>zurück</Navbar.Text>
                                </>
                            }
                          </Container>
                        </Navbar>     

                        {menuMap[this.state.page].content}
                      </>
              );
            } else {
              return (
                <Container fluid>
                  <Spinner animation="border" role="status" style={{marginTop: '10em'}} />
                </Container>
              );
            }

    }
}